import { ApiProperty } from "@nestjs/swagger";

export class MetalDetectionDto {
    @ApiProperty()
    metalDetectionId: number;
    @ApiProperty()
    date: Date;
    @ApiProperty()
    minGrade: number;
    @ApiProperty()
    maxGrade: number;
    @ApiProperty()
    variety: number;
    @ApiProperty()
    brand: number;
    @ApiProperty()
    sCode: string;
    @ApiProperty()
    operation: string;
    @ApiProperty()
    mmFe: boolean;
    @ApiProperty()
    mmNonFe: boolean;
    @ApiProperty()
    mmSS: boolean;
    @ApiProperty()
    minPouches: number;
    @ApiProperty()
    maxPouches: number;
    @ApiProperty()
    metalDetected: boolean;
    @ApiProperty()
    correctiveAction: string
    @ApiProperty()
    plant: number;
    @ApiProperty()
    createdUser: string;
    @ApiProperty()
    updatedUser: string;
    @ApiProperty()
    brandName?: string;
    @ApiProperty()
    varietyName?: string;
}